let premiumGroups = {}

function calculateEventPremiums (payoutSettings, showResults, shows) {
  premiumGroups = {}
  showResults.forEach(sr => {
    let payoutGroup = payoutSettings.payout_groups.find(pg => {
      if (pg.shows.some(s => s.show_id === sr.show_id)) {
        return pg
      }
    })
    if (sr.show_book) {
      sr.show_book.forEach(c => {
        if (c.entryType === 'standard') {
          c.entries.forEach(e => {
            if (e.place) {
              let totalAmount = 0
              let classSize = c.entries.filter(e => e.place !== 'SCRATCH').length
              if (payoutGroup.class_percentage_based) {
                let show = shows.find(s => s.show_id === sr.show_id)
                totalAmount = show.pricing_details.rate * classSize
                // Check for added money
                if (payoutGroup.class_added_money) {
                  totalAmount += payoutGroup.class_added_money
                }
              }
              if (payoutGroup.class_size_variation) {
                if (parseInt(e.place)) {
                  let amount = payoutGroup.class_size_placings[classSize - 1][e.place - 1]
                  if (payoutGroup.class_percentage_based) {
                    amount = totalAmount * (amount / 100)
                  }
                  if (amount) {
                    addToPremiumGroupStandard(e, payoutGroup, sr.name, amount)
                  }
                }
              } else {
                let amount = payoutGroup.class_placings[e.place - 1]
                if (payoutGroup.class_percentage_based) {
                  amount = totalAmount * (amount / 100)
                }
                if (amount) {
                  addToPremiumGroupStandard(e, payoutGroup, sr.name, amount)
                }
              }
            }
          })
        } else if (c.entryType === 'Champion') {
          if (!c.settings) {
            c.settings = {}
          }
          // if (c.winner && (c.settings ? c.settings.champion_type !== 'WRITE' : true)) {
          if (c.winner && c.settings.champion_type !== 'WRITE') {
            let exhibitorID = c.winner.exhibitor_id
            if (!exhibitorID) {
              sr.show_book.forEach(cl => {
                if (cl.entryType === 'standard') {
                  cl.entries.forEach(e => {
                    if (c.winner.entry_id === e.entry_id) {
                      exhibitorID = e.exhibitor.exhibitor_id
                    }
                  })
                }
              })
            }
            if (c.division === 'Overall') {
              if (payoutGroup.overall_champions) {
                addToPremiumGroupOverall(exhibitorID, payoutGroup, sr.name, c, sr, shows)
              }
            } else {
              if (payoutGroup.division_champions) {
                addToPremiumGroupDivision(exhibitorID, payoutGroup, sr.name, c, sr, shows)
              }
            }
          }
        }
      })
    }
  })
  return premiumGroups
}

function addToPremiumGroupStandard (entry, payoutGroup, showName, amount) {
  if (!premiumGroups[entry.exhibitor.exhibitor_id]) {
    premiumGroups[entry.exhibitor.exhibitor_id] = {
      premium_total: amount,
      details: [
        {
          show_name: showName,
          animal_id: entry.entry_details.animal_id,
          amount: amount,
          division: entry.division,
          placing: entry.place,
          type: 'Class Placing'
        }
      ]
    }
  } else {
    premiumGroups[entry.exhibitor.exhibitor_id].premium_total += amount
    premiumGroups[entry.exhibitor.exhibitor_id].details.push({
      show_name: showName,
      amount: amount,
      animal_id: entry.entry_details.animal_id,
      division: entry.division,
      placing: entry.place,
      type: 'Class Placing'

    })
  }
}

function addToPremiumGroupOverall (exhibitorID, payoutGroup, showName, c, sr, shows) {
  let amount = 0
  let totalAmount = 0
  if (payoutGroup.overall_percentage_based) {
    let divisionSize = 0
    sr.show_book.forEach(cl => {
      if (cl.entryType === 'standard') {
        divisionSize += cl.entries.filter(e => e.place !== 'SCRATCH').length
      }
    })
    let show = shows.find(s => s.show_id === sr.show_id)
    totalAmount = show.pricing_details.rate * divisionSize
    // Check for added money
    if (payoutGroup.overall_added_money) {
      totalAmount += payoutGroup.overall_added_money
    }
  }
  Object.keys(payoutGroup.overall_champions).forEach(k => {
    const regex = new RegExp(k, 'gi')
    if (c.calculated_class_name ? c.calculated_class_name.match(regex) : c.class_name.match(regex)) {
      if (payoutGroup.overall_percentage_based) {
        amount = totalAmount * (payoutGroup.overall_champions[k] / 100)
      } else {
        amount = payoutGroup.overall_champions[k]
      }
    }
  })
  if (premiumGroups[exhibitorID]) {
    premiumGroups[exhibitorID].premium_total += amount
    premiumGroups[exhibitorID].details.push({
      show_name: showName,
      amount: amount,
      animal_id: c.winner.animal_id,
      division: c.division,
      type: 'Overall Placing'
    })
  } else {
    premiumGroups[exhibitorID] = {
      premium_total: amount,
      details: [
        {
          show_name: showName,
          amount: amount,
          animal_id: c.winner.animal_id,
          division: c.division,
          type: 'Overall Placing'
        }
      ]
    }
  }
}

function addToPremiumGroupDivision (exhibitorID, payoutGroup, showName, c, sr, shows) {
  let amount = 0
  let totalAmount = 0
  if (payoutGroup.division_percentage_based) {
    let divisionSize = 0
    sr.show_book.filter(cl => cl.division === c.division).forEach(cl => {
      if (cl.entryType === 'standard') {
        divisionSize += cl.entries.filter(e => e.place !== 'SCRATCH').length
      }
    })
    let show = shows.find(s => s.show_id === sr.show_id)
    totalAmount = show.pricing_details.rate * divisionSize
    // Check for added money
    if (payoutGroup.division_added_money) {
      totalAmount += payoutGroup.division_added_money
    }
  }
  let divisionGroup = payoutGroup.division_champions[c.division] ? payoutGroup.division_champions[c.division] : payoutGroup.division_champions.default
  if (divisionGroup) {
    Object.keys(divisionGroup).forEach(k => {
      const regex = new RegExp(k, 'gi')
      if (c.calculated_class_name ? c.calculated_class_name.match(regex) : c.class_name.match(regex)) {
        if (payoutGroup.division_percentage_based) {
          amount = totalAmount * (divisionGroup[k] / 100)
        } else {
          amount = divisionGroup[k]
        }
      }
    })
    // Need to add so that it will add if misssing
    if (premiumGroups[exhibitorID]) {
      premiumGroups[exhibitorID].premium_total += amount
      premiumGroups[exhibitorID].details.push({
        show_name: showName,
        amount: amount,
        animal_id: c.winner.animal_id,
        division: c.division,
        type: `Division Placing (${c.division})`
      })
    } else {
      premiumGroups[exhibitorID] = {
        premium_total: amount,
        details: [
          {
            show_name: showName,
            animal_id: c.winner.animal_id,
            amount: amount,
            division: c.division,
            type: `Division Placing (${c.division})`
          }
        ]
      }
    }
  }
}

export default {
  calculateEventPremiums
}
